// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Reprocessos_CriarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/reprocessos/criar
 *
 * Opens a new reprocess record for an order item, documenting the problem
 * with a before photo. Source and status are set by the controller.
 */
import { registerContract } from './validate'

export interface Reprocessos_CriarInput {
order_item_id: number
production_step_id: number
photo_before: string
work_order_step_id?: number
notes?: string
}

registerContract('Reprocessos_CriarInput', {
  order_item_id:      { type: 'number',  required: true },
  production_step_id: { type: 'number',  required: true },
  photo_before:       { type: 'string',  required: true },
  work_order_step_id: { type: 'number',  required: false },
  notes:              { type: 'string',  required: false },
})
